<div
  class="form-line"
  [class.form-line-full-width]="isFullWidth()"
  [class.form-line-quarter-width]="isQuarterWidth()"
>
  <ng-content />
</div>
